module.exports = __webpack_public_path__ + "media/CN_003.ec50cab1.mp3";